import $ from 'jquery';

import './fields/validator';
import './fields/character-counter';
import './fields/radio-group-validator';

import './fields/floating-label';
import stateModifiers from './fields/state-modifiers';
import iconifyBehaviors from './fields/iconify-behaviors';
import iconifyDetails from './fields/iconify-details';

$(document).ready(() => {

  $(document.querySelectorAll('[data-validate]')).validator();
  $(document.getElementsByClassName('character-counter-field')).characterCounter();
  $(document.getElementsByClassName('character-counter-field-input')).characterCounter({
    fieldSelector: 'input',
  });
  $(document.getElementsByClassName('validate-radio-group')).radioGroupValidator({
    errorClassName: 'form-section__error',
  });

  const stateModifiersCaller = stateModifiers();
  const iconifyBehaviorsCaller = iconifyBehaviors();
  const iconifyDetailsCaller = iconifyDetails();
  $(document.getElementsByClassName('floating-label')).floatingLabel({
    callers: [stateModifiersCaller, iconifyBehaviorsCaller, iconifyDetailsCaller],
  });
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/elements/elements.js